import PropTypes from 'prop-types';
import React from 'react';
import { Image, Button, ButtonGroup } from 'react-bootstrap';
import Avatar from 'react-avatar';
import Dropzone from 'react-dropzone';
import moment from 'moment';
import TourState from './TourState';
import TourEditModal from './TourEditModal';

class TourHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { show: false };
    this.closeModal = this.closeModal.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }
  onDrop(acceptedFiles) {
    this.setState({
      files: acceptedFiles,
    });
    this.props.editTourImage(this.props.tour.id, acceptedFiles);
  }
  getTourButtons(state, isTourManager, readyToActivate) {
    if (isTourManager) {
      return null;
    }
    const edit = (
      <Button bsStyle="default" bsSize="small" onClick={this.handleEdit}>
        <i className="fa fa-pencil" /> Edit
      </Button>
    );
    const activate = (
      <Button
        bsStyle="info"
        bsSize="small"
        onClick={this.handleClick}
        data-item="AC"
        title="Active tours are available to members using the mobile app."
      >
        <i className="fa fa-magic" /> Send to Tour Members
      </Button>
    );
    const archive = (
      <Button bsStyle="success" bsSize="small" onClick={this.handleClick} data-item="AR">
        <i className="fa fa-trash" /> Archive
      </Button>
    );
    const unarchive = (
      <Button bsStyle="success" bsSize="small" onClick={this.handleClick} data-item="DR">
        <i className="fa fa-trash" /> Unarchive
      </Button>
    );

    switch (state) {
      case 'DR':
        if (readyToActivate) {
          return (
            <ButtonGroup>
              {edit}
              {activate}
              {archive}
            </ButtonGroup>
          );
        }
        return (
          <ButtonGroup>
            {edit}
            {archive}
          </ButtonGroup>
        );
      case 'AC':
        return (
          <ButtonGroup>
            {edit}
            {archive}
          </ButtonGroup>
        );
      case 'AR':
        return <ButtonGroup>{unarchive}</ButtonGroup>;
      default:
        return null;
    }
  }
  handleClick(e) {
    e.preventDefault();
    const payload = {};
    payload.state = e.currentTarget.getAttribute('data-item');
    this.props.editTour(this.props.tour.id, payload);
  }
  handleEdit(e) {
    e.preventDefault();
    this.setState({
      show: true,
    });
  }
  closeModal() {
    this.setState({
      show: false,
    });
  }
  renderImage(src) {
    if (src) {
      return (
        <Dropzone
          accept="image/*"
          ref={node => {
            this.dropzone = node;
          }}
          onDrop={this.onDrop}
          multiple={false}
          className="tour-image tour-image-details"
          acceptClassName="drop-accept"
          rejectClassName="drop-reject"
        >
          <Image src={src} responsive className="avatar" />
        </Dropzone>
      );
    }
    return (
      <Dropzone
        accept="image/*"
        ref={node => {
          this.dropzone = node;
        }}
        onDrop={this.onDrop}
        multiple={false}
        className="tour-image tour-image-details"
        acceptClassName="drop-accept"
        rejectClassName="drop-reject"
      >
        <Avatar name={this.props.tour.name} color="#326a34" size={75} className="avatar" />
      </Dropzone>
    );
  }
  render() {
    const start = moment(this.props.tour.start);
    const end = moment(this.props.tour.end);
    let tourDate = '';
    if (start.isValid()) {
      tourDate = `${start.format('MMMM Do YYYY')} - ${end.format('MMMM Do YYYY')}`;
    }
    const image = this.renderImage(this.props.tour.image);
    const readyToActivate =
      this.props.tour.members.length > 0 && this.props.tour.tour_stops.length > 0;
    const tourButtons = this.getTourButtons(
      this.props.tour.state,
      this.props.isTourManager,
      readyToActivate
    );
    return (
      <div className="tour-header container-fuild">
        {image}
        <div className="tour-title">
          <h2>
            {this.props.tour.name}: <span>{this.props.tour.tag_line}</span>
          </h2>
          <div className="tour-info">
            <div className="tour-date">
              {tourDate} <TourState state={this.props.tour.state} />
            </div>
            {tourButtons}
          </div>
        </div>
        <div className="clearfix" />
        {this.state.show && (
          <TourEditModal
            tour={this.props.tour}
            show={this.state.show}
            onClose={this.closeModal}
            addTour={this.props.addTour}
            editTour={this.props.editTour}
            requestTourManagers={this.props.requestTourManagers}
            tourManagers={this.props.tourManagers}
          />
        )}
      </div>
    );
  }
}

TourHeader.propTypes = {
  tour: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tag_line: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    image: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    created_on: PropTypes.string,
    updated_on: PropTypes.string,
    sent_to_manager: PropTypes.string,
    travel_agency: PropTypes.number,
    notes: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  addTour: PropTypes.func.isRequired,
  editTour: PropTypes.func.isRequired,
  editTourImage: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
};

TourHeader.defaultProps = {
  tour: {
    state: 'draft',
    start: null,
    end: null,
    // image: 'https://www.whyy.org/img/ontour_logocrop.png',
  },
};

export default TourHeader;



// WEBPACK FOOTER //
// src/routes/tours/components/TourHeader.js